import { render, staticRenderFns } from "./CategoryFiltersMobile.vue?vue&type=template&id=24d4d84c&"
import script from "./CategoryFiltersMobile.vue?vue&type=script&lang=js&"
export * from "./CategoryFiltersMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports